import "./contactcomp.css"
import React from 'react'
import Emailjs from "emailjs-com"

const ContactComp = () => {

const sendEmail = (e) => {
  e.preventDefault();

  Emailjs.sendForm(
    "service_h35tlrq",
    "template_qty7crm",
    e.target,
    "KTAR-EbqNhNQvWNxH"
  ).then((res) => {
    console.log(res);
    alert("Your Email Has been seen")
    alert("Your Email Has been seen")
  }).catch((err) => {
    console.log(err);
    alert("There is some error")
  });
}

  return (
    <>
      <div className="contact">
        <h1>Have You Any Question?</h1>
        <p className="slogan">I'M AT YOUR SERVICE</p>
        <div className="contact-info">
          <div className="information">
            <i className="fa-solid fa-phone"></i>
            <h4>Call me on</h4>
            <p>+92 311 3318633</p>
          </div>
          <div className="information">
            <i className="fa-solid fa-location-dot"></i>
            <h4>Location</h4>
            <p>Hyderabad</p>
          </div>
          <div className="information">
            <i className="fa-solid fa-envelope"></i>
            <h4>Email</h4>
            <p>hk7356231@gmail.com</p>
          </div>
          <div className="information">
            <i className="fa-solid fa-globe"></i>
            <h4>Website</h4>
            <p>www.domain.com</p>
          </div>
        </div>
        <div className="contact-form">
          <h1>SEND ME A EMAIL</h1>
          <p className="slogan">I'M RESPONSIVE TO MASSAGE</p>
          <form action="/" className="form" onSubmit={sendEmail}>
            <input type="text" name="name" placeholder="Enter Your Name" />
            <input type="email" name="email" placeholder="Enter Your Email" />
            <input type="text" name="subject" placeholder="Subject" />
            <textarea name="massage" rows="5" placeholder="Massage" ></textarea>
            <button className="btn-light" type="submit">Send<i className="fa-solid fa-share"></i></button>
          </form>
        </div>
      </div>
    </>
  )
}

export default ContactComp